<div class="support-wrapper">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <h1>Support & Disputes</h1>
  <p class="support-description">
    Need help with a refund or have a dispute? We're here to help you resolve any issues
    with your gaming experience.
  </p>

  <div class="support-form">
    <form [formGroup]="supportForm" (ngSubmit)="submitRequest()">
      <h2>Contact Support</h2>

      <div class="form-group">
        <label for="subject">Subject</label>
        <input id="subject" formControlName="subject" type="text" placeholder="Subject">
      </div>

      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" formControlName="description" placeholder="Describe your issue"></textarea>
      </div>

      <div class="btn-wrapper">
        <button class="submit-btn btn" type="submit" [disabled]="supportForm.invalid">
          Submit Request
        </button>
      </div>
    </form>
  </div>
</div>

<app-modal
  class="submit-btn-modal"
  [isOpen]="isSubmitted"
  [icon]="'assets/images/info.png'"
  [title]="'Request and submitted!'"
  [text]="'Check your email. Our team will get back to you soon.'"
  [primaryBtnText]="'Home Page'"
  (primaryClick)="goHome()"
  (close)="isSubmitted = false">
</app-modal>

